export const environment = {
  production: false,
  baseUrl: 'https://designguide.redebanvoucherdigital.com',
  host: 'Develop',
};